import React from 'react';
import Icon from './Icon';

class Rating extends React.Component {

    static buttons = [
        {
            'label': 'Inte så bra',
            'rating': 1
        },
        {
            'label': 'Kommer nog inte att göre igen',
            'rating': 2
        },
        {
            'label': 'Helt ok!',
            'rating': 3
        },
        {
            'label': 'Mycket gott!',
            'rating': 4
        },
        {
            'label': 'Världsklass!',
            'rating': 5
        },
    ]

    static cookieName = 'RecipeRating'

    constructor(props) {
        super(props);

        let rating = 0.0; 
        if (this.props.post.meta_data.recipeRating) {
            const ratingObject = JSON.parse(this.props.post.meta_data.recipeRating);
            rating = parseFloat(ratingObject.totalRating / ratingObject.count).toFixed(1);
            this.state = {
                rating: rating,
                count: ratingObject.count
            }
        } else {
            this.state = {
                rating: 0,
                count: 0
            }
        }

        this.doRate = this.doRate.bind(this);
    }

    doRate(rating) {
        const ratings = this.getCookieRating();
        if (this.state.running ||
            ratings[this.props.post.id.toString()]) {
            return;
        }

        axios.post(
            `/api/rating/${this.props.post.id}/`, 
            { rating: rating }
        )
        .then((response) => {
            ratings[this.props.post.id.toString()] = rating;
            window.Cookie.set(Rating.cookieName, JSON.stringify(ratings), { expires: (365 * 10) });
            this.setState({
                rating: parseFloat(response.data).toFixed(1),
                count: ++this.state.count
            });
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            this.setState({
                running: false
            });
        });
    }

    getCookieRating() {
        let reactionsJSON = window.Cookie.get(Rating.cookieName);
        if (typeof reactionsJSON == 'undefined') {
            return {};
        }
        return JSON.parse(reactionsJSON);
    }

    render() {
        const stars = Rating.buttons.map((btn, i) => {
            return (
                <button className={`rating_vote-btn ${this.state.rating >= btn.rating ? 'rating_vote-btn__filled' : ''}` } key={btn.rating} onClick={ () => {this.doRate(btn.rating)}}>
                    <Icon type="star_on" />
                </button>
            );
        });
        return (
            <div className={'rating_container'}>
                <div className={'rating_vote-btn-container'}>
                    {stars}
                </div>
                <p className={'rating_text'}>{this.state.count} röster</p>
            </div>
        );
    }
}

export default Rating;